// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"jP","mainContent":"kP","activeSidebar":"lP"};